let evlDate = "all";
let evlLocation = "all";

let evlVisibleCount = 5;

function evlToggle(el) {
  el.parentElement.classList.toggle("evl-active");
}

function evlSetActive(el) {
  let group = el.closest('.evl-acc-body');

  if (group) {
    group.querySelectorAll('.evl-filter').forEach(btn => btn.classList.remove('evl-active'));
  }

  el.classList.add('evl-active');
}

function evlFilterLocation(loc, el) {
  evlLocation = loc;
  evlVisibleCount = 5;
  evlSetActive(el);
  evlSyncTags(loc);
  evlApply();
}

function evlFilterDate(type, el) {
  evlDate = type;
  evlVisibleCount = 5;
  evlSetActive(el);
  evlApply();
}

function evlGetDates() {
  let now = new Date();

  let today = new Date(now);
  let tomorrow = new Date(now);
  tomorrow.setDate(today.getDate() + 1);

  let weekStart = new Date(now);
  let day = weekStart.getDay();
  let diff = weekStart.getDate() - day + (day === 0 ? -6 : 1);
  weekStart.setDate(diff);

  let weekEnd = new Date(weekStart);
  weekEnd.setDate(weekStart.getDate() + 6);

  return {
    today: today.toISOString().split('T')[0],
    tomorrow: tomorrow.toISOString().split('T')[0],
    weekStart,
    weekEnd
  };
}

function evlApply() {

  let { today, tomorrow, weekStart, weekEnd } = evlGetDates();

  let visibleIndex = 0;
  let totalMatched = 0;

  document.querySelectorAll('.evl-card').forEach(card => {

    let cDate = card.dataset.date;
    let cMonth = card.dataset.month;
    let cLoc = card.dataset.location;

    let eventDateObj = new Date(cDate);

    let dateMatch = false;

    if (evlDate === "all") {
      dateMatch = true;

    } else if (evlDate === "today") {
      dateMatch = (cDate === today);

    } else if (evlDate === "tomorrow") {
      dateMatch = (cDate === tomorrow);

    } else if (evlDate === "week") {
      dateMatch = (eventDateObj >= weekStart && eventDateObj <= weekEnd);

    } else if (evlDate === "weekend") {
      let d = eventDateObj.getDay(); 
      dateMatch = (d === 0 || d === 6);

    } else {
      dateMatch = (cMonth === evlDate);
    }

    let locMatch =
      evlLocation === "all" || evlLocation === cLoc;

    if (dateMatch && locMatch) {
      totalMatched++;

      if (visibleIndex < evlVisibleCount) {
        card.style.display = "flex";
        visibleIndex++;
      } else {
        card.style.display = "none";
      }

    } else {
      card.style.display = "none";
    }

  });

  let btnWrap = document.querySelector('.evl-showmore-wrap');

  if (btnWrap) {
    if (totalMatched > evlVisibleCount) {
      btnWrap.style.display = "block";
    } else {
      btnWrap.style.display = "none";
    }
  }
}

function evlShowMore() {
  evlVisibleCount += 5;
  evlApply();
}

function evlInitLocations() {
  let set = new Set();

  document.querySelectorAll('.evl-card').forEach(c => {
    set.add(c.dataset.location);
  });

  let box = document.getElementById('evlLocationTags');
  if (!box) return;

  box.innerHTML = '';

  let all = document.createElement('div');
  all.className = 'evl-tag evl-active';
  all.innerText = 'All';
  all.dataset.value = 'all';
  all.onclick = () => { evlFilterLocation('all', all); evlSetTag(all); };
  box.appendChild(all);

  set.forEach(loc => {
    let tag = document.createElement('div');
    tag.className = 'evl-tag';
    tag.innerText = loc;
    tag.dataset.value = loc;

    tag.onclick = () => {
      evlFilterLocation(loc, tag);
      evlSetTag(tag);
    };

    box.appendChild(tag);
  });
}

function evlSetTag(el) {
  document.querySelectorAll('.evl-tag').forEach(t => t.classList.remove('evl-active'));
  el.classList.add('evl-active');
}

function evlSyncTags(loc) {
  document.querySelectorAll('.evl-tag').forEach(tag => {
    tag.classList.remove('evl-active');

    if (
      tag.dataset.value === loc ||
      (loc === 'all' && tag.dataset.value === 'all')
    ) {
      tag.classList.add('evl-active');
    }
  });
}

document.addEventListener("DOMContentLoaded", function () {
  evlInitLocations();
  evlApply();
});